export default __webpack_public_path__ + "e4639b070105da797312c0b806ee4942.woff2";